import { hdcBillUpcomingMock, hdcInfo } from "../builders/createInsuranceBill";
import { cigHdcUpcomingBill } from "../builders/createCigBill";
import { legacyCanadaSecondGearMember } from "../mockMembers";
import { getHdc1Dot0Membership } from "../builders/getHdc1Dot0Membership";
import { getMockPolicies } from "../builders/getMockPolicies";
import { MockPolicyId } from "../mockPolicies";

import { MockPersona } from "./mockPersonas.types";

const hdcLevel = 2;
const canadaPolicies: MockPolicyId[] = ["CD829471-01"];

export const katyLetterkenny: MockPersona = {
  key: "katyLetterkenny",
  name: "Katy Letterkenny",
  description: "🇨🇦 | One core policy | HDC 1.0 Single-tier | Upcoming HDC Bill (no autopay)",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [cigHdcUpcomingBill("1.0", {})],
      },
      policies: {
        usa: [],
        canada: getMockPolicies(...canadaPolicies),
      },
    },
    hdc: {
      fetch1Dot0Membership: getHdc1Dot0Membership({ ProductCode: "USMEMB2" }),
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "katy@letterkenny.com",
            firstName: "Katy",
            middleName: "",
            lastName: "Letterkenny",
            mailingAddress: {
              line1: "337 Queen Street West",
              line2: "",
              city: "Letterkenny",
              state: "ON",
              postalCode: "M5V 2A4",
              country: "CANADA",
            },
            preferredPhone: "4378122785",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000017",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: legacyCanadaSecondGearMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [hdcBillUpcomingMock({ id: "1" })],
          outstandingBalance: hdcInfo[hdcLevel - 1].cost,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
